<template>
  <div>
    <WelcomeVideo v-if="showWelcomeVideo()" />
    <WhatsHappeningCurrentEntries :entries="entriesForCurrentBox()" :isCurrent="!!currentEntry"/>
    <Timer v-if="currentEntry" :time="currentEntry.ends_at" :entryType="currentEntry.type" startsOrEnds="ends" />
    <Timer v-else-if="nextEntry" :time="nextEntry.starts_at" :entryType="nextEntry.type"  startsOrEnds="starts" />
    <WhatsHappeningNextEntries :entries="nextEntries()" v-if="showNextEntry()"/>
  </div>
</template>

<script>
import _ from 'lodash'
import Vue from 'vue'
import WhatsHappeningCurrentEntries from './WhatsHappeningCurrentEntries'
import WhatsHappeningNextEntries from './WhatsHappeningNextEntries'
import WelcomeVideo from './WelcomeVideo'
import AskDelegateAboutSupplierController from './AskDelegateAboutSupplierController'
import Timer from './Timer'
import { mapState } from 'vuex'

export default {
  name: 'WhatsHappening',
  props: ['entries'],
  components: {WhatsHappeningCurrentEntries, WhatsHappeningNextEntries, Timer, WelcomeVideo},
  created() {
    if (this.attendee.type == 'delegate') {
      new (Vue.extend(AskDelegateAboutSupplierController))({
        store: this.$store,
        propsData: {
          delegate: this.attendee,
          entries: this.entries,
          currentEntry: this.currentEntry
        }
      })
    }
  },
  computed: {
    ...mapState(['attendee']),
    nextEntry() {
      return _.find(this.entries, (entry) => {
        return new Date(entry.starts_at) > this.$store.state.currentTime
      })
    },
    currentEntry() {
      return _.find(this.entries, (entry) => {
        return new Date(entry.starts_at) <= this.$store.state.currentTime &&
          new Date(entry.ends_at) > this.$store.state.currentTime;
    })},
    timerEntry() {
      return this.currentEntry || this.nextEntry
    },
  },
  methods: {
    entriesForCurrentBox() {
      if (this.currentEntry) {
        return this.currentEntries()
      } else {
        return this.nextEntries()
      }
    },
    nextEntries() {
      if (!this.nextEntry) { return [] }

      return this.entries.filter((entry) => {
        return entry.starts_at == this.nextEntry.starts_at
      })
    },
    currentEntries() {
      if (!this.currentEntry) { return [] }

      return this.entries.filter((entry) => {
        return entry.starts_at == this.currentEntry.starts_at
      })
    },
    showNextEntry() {
      return this.currentEntry && this.nextEntry
    },
    showWelcomeVideo() {
      return this.attendee.attending_online && this.beforeFirstEntryJoinableOnline()
    },
    beforeFirstEntryJoinableOnline() {
      let firstEntryJoinableOnline = _.find(this.entries, (entry) => {
        return !!entry.join_url;
      })

      if (!this.currentEntry) { return true }

      return this.$store.state.currentTime < new Date(firstEntryJoinableOnline.starts_at)
    }
  }
}
</script>

<style lang="scss">
</style>
